module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "page-bar"
  }, [_c('breadcrumb', {
    attrs: {
      "crumbs": _vm.breadcrumbArray
    }
  })], 1), _vm._v(" "), _c('h1', {
    staticClass: "page-title"
  }, [_vm._v("Social Feed")]), _vm._v(" "), _vm._m(0, false, false), _vm._v(" "), (_vm.socialFeed.length) ? _c('div', [_c('h5', [_vm._v("Filter By:")]), _vm._v(" "), _c('button-group', {
    attrs: {
      "value": _vm.filterBy,
      "type": "primary"
    }
  }, [_c('checkbox', {
    attrs: {
      "value": "facebook"
    }
  }, [(_vm.filterBy.indexOf('facebook') >= 0) ? _c('span', [_c('i', {
    staticClass: "fa fa-check green"
  }), _vm._v("  ")]) : _vm._e(), _vm._v("Facebook")]), _vm._v(" "), _c('checkbox', {
    attrs: {
      "value": "twitter"
    }
  }, [(_vm.filterBy.indexOf('twitter') >= 0) ? _c('span', [_c('i', {
    staticClass: "fa fa-check green"
  }), _vm._v("  ")]) : _vm._e(), _vm._v("Twitter")]), _vm._v(" "), _c('checkbox', {
    attrs: {
      "value": "instagram"
    }
  }, [(_vm.filterBy.indexOf('instagram') >= 0) ? _c('span', [_c('i', {
    staticClass: "fa fa-check green"
  }), _vm._v("  ")]) : _vm._e(), _vm._v("Instagram")])], 1)], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "margin-top-20"
  }, [_c('div', {
    staticClass: "relative-block"
  }, [(_vm.filteredSocialFeed.length) ? _c('div', {
    staticClass: "clearfix"
  }, [_c('el-dropdown', {
    attrs: {
      "trigger": "click",
      "size": "mini",
      "show-timeout": 50,
      "hide-timeout": 50
    },
    on: {
      "command": _vm.updateSortByOrder
    }
  }, [_c('el-button', {
    attrs: {
      "size": "mini"
    }
  }, [_vm._v("\n\t        \t\t\t\tSort by\n\t        \t\t\t\t"), _c('span', [(_vm.sortBy.order === 'ASC') ? _c('i', {
    staticClass: "fa fa-sort-alpha-asc"
  }) : _vm._e(), _vm._v(" "), (_vm.sortBy.order === 'DESC') ? _c('i', {
    staticClass: "fa fa-sort-alpha-desc"
  }) : _vm._e()]), _vm._v(" "), _c('i', {
    staticClass: "el-icon-arrow-down el-icon--right"
  })]), _vm._v(" "), _c('el-dropdown-menu', {
    attrs: {
      "slot": "dropdown"
    },
    slot: "dropdown"
  }, [_c('el-dropdown-item', {
    attrs: {
      "command": "ASC"
    }
  }, [_c('i', {
    staticClass: "fa fa-sort-alpha-asc"
  })]), _vm._v(" "), _c('el-dropdown-item', {
    attrs: {
      "command": "DESC"
    }
  }, [_c('i', {
    staticClass: "fa fa-sort-alpha-desc"
  })])], 1)], 1), _vm._v(" "), _c('page-results', {
    staticClass: "pull-right",
    attrs: {
      "totalResults": _vm.totalResults,
      "activePage": _vm.activePage
    },
    on: {
      "pageResults": _vm.pageResultsUpdate
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "blog-page blog-content-1 relative-block margin-top-20"
  }, [_c('loading-screen', {
    attrs: {
      "show": _vm.loadingFilteredData,
      "color": '#2C3E50',
      "display": 'inline'
    }
  }), _vm._v(" "), (!_vm.loadingFilteredData && _vm.socialFeed.length) ? _c('div', [(_vm.filteredSocialFeed.length) ? _c('div', {
    staticClass: "row"
  }, _vm._l((_vm.filteredSocialFeed), function(feed, index) {
    return _c('div', {
      key: index,
      staticClass: "col-md-3 col-sm-3 col-xs-4"
    }, [_c('div', {
      staticClass: "blog-post-sm blog-container blog-shadow",
      attrs: {
        "id": 'social-feed-' + feed.id
      }
    }, [_c('div', {
      staticClass: "blog-top-wrap"
    }, [_c('div', {
      staticClass: "pull-left"
    }, [(feed.short_description.length) ? _c('span', [_vm._v(_vm._s(feed.short_description))]) : _c('span', [_vm._v("NO TITLE")])])]), _vm._v(" "), _c('div', {
      staticClass: "blog-img-thumb small-blog-img-thumb",
      class: {
        'blog-img-thumb-bordered': !feed.url.length
      }
    }, [_c('a', [(feed.url.length) ? _c('img', {
      attrs: {
        "src": feed.img_full_url
      }
    }) : _c('img', {
      staticClass: "small-image",
      attrs: {
        "src": require("../../assets/img/app/image-placeholder.png")
      }
    })])]), _vm._v(" "), _c('div', {
      staticClass: "blog-post-content"
    }, [_c('p', {
      staticClass: "blog-post-desc"
    }, [_vm._v(" " + _vm._s(feed.description) + " ")]), _vm._v(" "), (feed.facebook || feed.twitter || feed.instagram) ? _c('div', {
      staticClass: "blog-post-foot"
    }, [_c('div', {
      staticClass: "socicons"
    }, [(feed.facebook) ? _c('a', {
      staticClass: "socicon-btn socicon-btn-circle socicon-facebook"
    }) : _vm._e(), _vm._v(" "), (feed.twitter) ? _c('a', {
      staticClass: "socicon-btn socicon-btn-circle socicon-twitter"
    }) : _vm._e(), _vm._v(" "), (feed.instagram) ? _c('a', {
      staticClass: "socicon-btn socicon-btn-circle socicon-instagram"
    }) : _vm._e()])]) : _vm._e(), _vm._v(" "), (feed.status === 1) ? _c('button', {
      staticClass: "btn btn-danger custom-button full-width",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.updateFeedStatus(feed, 0)
        }
      }
    }, [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\tOff\n\t\t\t\t\t\t\t\t\t\t\t")]) : _vm._e(), _vm._v(" "), (feed.status === 0) ? _c('button', {
      staticClass: "btn btn-success custom-button full-width",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.updateFeedStatus(feed, 1)
        }
      }
    }, [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\tOn\n\t\t\t\t\t\t\t\t\t\t\t")]) : _vm._e()])])])
  })) : _vm._e()]) : _vm._e(), _vm._v(" "), (!_vm.loadingFilteredData && !_vm.socialFeed.length) ? _c('div', [_c('no-results', {
    attrs: {
      "show": true,
      "type": 'social feeds'
    }
  })], 1) : _vm._e()], 1), _vm._v(" "), (_vm.filteredSocialFeed.length) ? _c('div', {
    staticClass: "margin-top-20"
  }, [_c('pagination', {
    attrs: {
      "passedPage": _vm.activePage,
      "numPages": _vm.numPages
    },
    on: {
      "activePageChange": _vm.activePageUpdate
    }
  })], 1) : _vm._e()])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "note note-info"
  }, [_c('p', [_vm._v("Create and manage the Social Feed.")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-e5be15aa"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/app/SocialFeed.vue
// module id = 786
// module chunks = 0